import { SEVERITY_ICON, NO_DATA_ICON } from '../../constants';

export default (severity: number) => {
  return SEVERITY_ICON[severity] || NO_DATA_ICON;
};